import { createSelector } from 'reselect'

import { IOnboardingState } from '../models'

export const selectActionTransitionsData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.actionTransitionsData

export const selectActionTransitionsLoadingStatus = createSelector(
  [selectActionTransitionsData],
  ({ status }) => status
)
